export default __webpack_public_path__ + "assets/2fb2cbef303bc95bbac8d7b63a7d5473.png";